import { ImageLoaderConfig } from '@angular/common';
import { InjectionToken } from '@angular/core';
import { IResizeOptions, IResizeOptions as IResizeOptionsCore } from '@df/ui/common/resize.service';

export namespace NAkamai {
    export const DEFAULT_OPTIONS = {
        defaultOptions: {
            fillColor: 'FFFFFF'
        }
    };

    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_AKAMAI_OPTIONS', {
        providedIn: 'root',
        factory: () => DEFAULT_OPTIONS
    });

    export interface IModuleOptions {
        defaultOptions: Partial<IResizeOptions>;
    }

    export interface ILoaderConfig extends ImageLoaderConfig {
        loaderParams: IResizeOptionsCore;
    }
}

declare module '@df/ui/common/resize.service' {
    interface IResizeOptions {
        fitIn?: boolean | string;
        // Places a transparent image on a set background color.
        fillColor?: string;
        // Crop the image to specified coordinates
        // Base crop: width=<width_to_crop>,height=<height_to_crop>
        // Gravity crop: width=<width_to_crop>,height=<height_to_crop>,gravity=<gravity>
        // - gravity: North, South, East, West, NorthEast, NorthWest, SouthEast, SouthWest, Center (default)
        crop?: string;
        // Applies a method to detect faces in the source image and applies the rectangular crop on either the biggest face or all of the faces detected.
        faceCrop?: boolean;
        // Automatically crops the background uniformly from the edges of an image.
        trim?: boolean | number | string; // true or 1 for default trim, number for tolerance or
    }
}
